<template>
  <div class="cxbcSynthesis">
    <div class="cxbcSynthesis_hed">
      <div class="cxbcSynthesis_cet_hed_title">
        「重寻百草」深度体验中国百草文化
      </div>
      <div class="cxbcSynthesis_cet_hed_title2">寻草药 识草药 了解中医文化</div>
      <div class="cxbcSynthesis_cet_hed_title2">
        集齐五种草药可合成藏品优先购资格
      </div>
    </div>
    <div class="cxbcSynthesis_cet">
      <div class="cxbcSynthesis_cet_hed">
        <!-- <div class="rule" @click="topage('cxbcRule')"></div> -->
        <div class="rule" @click="rule = true"></div>
        <div
          class="min_btn"
          @click="confir()"
          v-if="
            (grass1 == 0 ||
              grass2 == 0 ||
              grass3 == 0 ||
              grass4 == 0 ||
              grass5 == 0) &&
            !synthesis
          "
        >
          <div class="f-16 m-b-5 bold text-center">合成</div>
          <div class="f-12 text-center">需消耗99元石</div>
        </div>
        <div
          class="min_btn"
          @click="confirm = true"
          v-if="
            grass1 != 0 &&
            grass2 != 0 &&
            grass3 != 0 &&
            grass4 != 0 &&
            grass5 != 0 &&
            !synthesis
          "
        >
          <div class="f-16 m-b-5 bold text-center">合成</div>
          <div class="f-12 text-center">需消耗99元石</div>
        </div>
        <div class="min_btn" @click="yxgzg()" v-if="synthesis">
          <div class="f-12 text-center">已获得优先购资格</div>
        </div>
        <!-- 第一排 -->
        <div
          class="top circle_style"
          @click="cliDetile('rs')"
          :style="{
            backgroundImage:
              grass2 == 0
                ? 'url(' + require('../../assets/img/cxbc/001.png') + ')'
                : 'url(' + require('../../assets/img/cxbc/01.png') + ')',
          }"
        >
          <div class="num">{{ grass2 }}</div>
        </div>
        <!-- 第二排左 -->
        <div
          class="mid_one circle_style"
          @click="cliDetile('blg')"
          :style="{
            backgroundImage:
              grass1 == 0
                ? 'url(' + require('../../assets/img/cxbc/005.png') + ')'
                : 'url(' + require('../../assets/img/cxbc/05.png') + ')',
          }"
        >
          <div class="num">{{ grass1 }}</div>
        </div>
        <!-- 第二排右 -->
        <div
          class="mid_two circle_style"
          @click="cliDetile('hl')"
          :style="{
            backgroundImage:
              grass3 == 0
                ? 'url(' + require('../../assets/img/cxbc/002.png') + ')'
                : 'url(' + require('../../assets/img/cxbc/02.png') + ')',
          }"
        >
          <div class="num">{{ grass3 }}</div>
        </div>
        <!-- 第三排左 -->
        <div
          class="lower_one circle_style"
          @click="cliDetile('ac')"
          :style="{
            backgroundImage:
              grass5 == 0
                ? 'url(' + require('../../assets/img/cxbc/004.png') + ')'
                : 'url(' + require('../../assets/img/cxbc/04.png') + ')',
          }"
        >
          <div class="num">{{ grass5 }}</div>
        </div>
        <!-- 第三排右 -->
        <div
          class="lower_two circle_style"
          @click="cliDetile('lz')"
          :style="{
            backgroundImage:
              grass4 == 0
                ? 'url(' + require('../../assets/img/cxbc/003.png') + ')'
                : 'url(' + require('../../assets/img/cxbc/03.png') + ')',
          }"
        >
          <div class="num">{{ grass4 }}</div>
        </div>
      </div>
      <div class="cxbcSynthesis_cet_btm"></div>
    </div>
    <div class="cxbcSynthesis_btm">
      <div class="operation_box">
        <div class="operation_box_title m-b-30">完成任务可抽签获得新药草</div>
        <div class="btn_box m-b-25">
          <div class="received" @click="openList()">收到的草药</div>
          <div class="extract" @click="lottery()">
            点击抽取({{ lotteryNum }})
          </div>
        </div>
        <div class="operation_box_title m-b-20">结束倒计时:{{ time }}</div>
        <div class="operation_box_jt m-b-10">
          <van-icon name="arrow-down" size="20" class="operation_box_jt" />
        </div>
        <div class="operation_box_popnum m-b-10">
          <img src="../../assets/img/cxbc/cx-right.png" alt="" />
          <span class="operation_box_popnums">参与人数:{{ count }}</span>
          <img src="../../assets/img/cxbc/cx-left.png" alt="" />
        </div>
        <div class="activity">
          <div class="activity_one m-b-20">
            <div class="left">
              <img src="../../assets/img/cxbc/gzh.jpg" alt="" />
              <div>
                <div class="f-14 bold">进入公众号发送对应口号</div>
                <div class="f-10">可获得1次抽签次数</div>
              </div>
            </div>
            <div class="right">
              <div class="btn" v-if="thePublic">已完成</div>
              <div class="btn" v-else @click="towc2()">去完成</div>
            </div>
          </div>
          <div class="activity_one m-b-20">
            <div class="left">
              <img src="../../assets/img/cxbc/activity-yq2.png" alt="" />
              <div>
                <div class="f-14 bold">进入社区发送对应口号</div>
                <div class="f-10">可获得1次抽签次数</div>
              </div>
            </div>
            <div class="right">
              <div class="btn" v-if="qunFG">已完成</div>
              <div class="btn" v-else @click="isShowGroup = true">去完成</div>
            </div>
          </div>
          <div class="activity_one">
            <div class="left">
              <img src="../../assets/img/cxbc/activity-yq1.png" alt="" />
              <div>
                <div class="f-14 bold">邀请好友收集百草</div>
                <div class="f-10">邀请好友越多 中签概率越大</div>
                <div class="f-10">好友成功预约即可获得抽签次数</div>
              </div>
            </div>
            <div class="right">
              <div class="btn" @click="topage('cxbcShare')">去邀请</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 获得草药弹窗 -->
    <van-overlay :show="getDrug" z-index="999">
      <div class="wrapper">
        <div class="block">
          <div class="getDrug">
            <div class="getDrug_title">获得草药</div>
            <div class="getDrug_imgbox">
              <img class="img" :src="getherbList[getherbnum].image" alt="" />
            </div>
            <div class="getDrug_brief">{{ getherbList[getherbnum].text }}</div>
            <div class="accept" @click="accept()">收下</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 抽到草药弹窗 -->
    <van-overlay :show="luckDrawDrug">
      <div class="wrapper">
        <div class="block">
          <div class="getDrug">
            <div class="getDrug_title">恭喜你抽到了</div>
            <div class="getDrug_imgbox">
              <img class="img" :src="getherbList[getherbnum].image" alt="" />
            </div>
            <div class="getDrug_brief">
              {{ getherbList[getherbnum].text }}
            </div>
            <div class="accept" @click="accept()">收下</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 未实名 -->
    <van-overlay :show="realName" z-index="999">
      <div class="wrapper">
        <div class="block">
          <div class="realName">
            <div class="realName_title">
              您还未完成实名<br />请完成实名后继续合成
            </div>
            <div class="to_realName" @click="topage('attest')">去实名</div>
            <div class="realName_tips">
              依据相关法律规定<br />获得数字藏品前需完成实名认证
            </div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="realName = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 确认合成 -->
    <van-overlay :show="confirm">
      <div class="wrapper">
        <div class="block" style="padding: 35px 50px 40px">
          <div class="confirm">
            <div class="confirm_title">是否消耗99元石合成?</div>
            <div class="confirm_title">
              剩余元石:<span style="margin-left: 8px">{{ user.stone }}</span>
            </div>
            <div class="btn_bx">
              <div class="cancel" @click="confirm = false">取消</div>
              <div class="confirm" @click="synthesiss()">确认</div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 未抽中 -->
    <van-overlay :show="NoPrize">
      <div class="wrapper">
        <div class="block">
          <div class="NoPrize">
            <div class="NoPrize_title">未抽中</div>
            <div class="NoPrize_wd">感谢您的参与,再试试吧~</div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="closeNoPrize()"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 没有可领取的草药 -->
    <van-overlay :show="NoDrug">
      <div class="wrapper">
        <div class="block">
          <div class="NoDrug">
            <div class="NoDrug_title">收到的草药</div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="realName = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 活动规则 -->
    <van-overlay :show="rule">
      <div class="wrapper">
        <div class="block" style="padding: 35px 25px 40px">
          <div class="rule">
            <div class="rule_title">活动规则</div>
            <div class="rule_wd">
              1. 集齐五张草药可合成百草图鉴，百草图鉴可解锁藏品优先购权限。
            </div>
            <div class="rule_wd">
              2. 参与藏品预约、实名认证、社群发送口号皆可获取一次抽签机会。
            </div>
            <div class="rule_wd">
              3.
              邀请好友预约藏品可获取抽签机会，其中邀请新用户可获得两次抽签机会，邀请人数不做限制。
            </div>
            <div class="rule_wd">4. 合成百草图鉴需完成实名认证。</div>
            <div class="rule_wd">5. 本次优先购名额2000名。</div>
            <div class="rule_wd">6. 合成百草图鉴需消耗99元石</div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="rule = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 领取列表 -->
    <van-overlay :show="DrugListFg">
      <div class="wrapper">
        <div class="block" style="padding: 35px 0 35px">
          <div class="DrugList">
            <div class="DrugList_title">收到的草药</div>
            <div class="user_list" v-if="DrugList.length != 0">
              <div class="user_list_title">
                <div style="#6E6C6C">收赠药草</div>
                <div style="#6E6C6C">赠送人</div>
                <div
                  class="user_list_title_btn"
                  v-if="DrugList[0].type == 0"
                  @click="allReceive()"
                >
                  一键领取
                </div>
                <div v-if="DrugList[0].type == 1" class="user_list_title_btn1">
                  已领取全部
                </div>
              </div>
              <div class="user_list_list">
                <div class="list" v-for="(item, i) in DrugList" :key="i">
                  <img class="cy" :src="giveimgList[item.grass].img" alt="" />
                  <div class="user">
                    <img
                      :src="
                        item.avator !== '0'
                          ? item.avator
                          : require('../../assets/img/user.png')
                      "
                      width="100%"
                      height="100%"
                      style="border-radius: 50%"
                    />
                    <span l>{{ item.username }}</span>
                  </div>
                  <div
                    class="listBtn"
                    v-if="item.type == 0"
                    @click="indiveReceive(item.id, item.grass, item.username)"
                  >
                    领取
                  </div>
                  <div v-if="item.type == 1" class="RevdBtn">已领取</div>
                </div>
              </div>
            </div>
            <div class="paging" v-if="DrugList.length != 0">
              <span @click="down()"><</span> {{ page }} / {{ last_page
              }}<span @click="add()"> ></span>
            </div>
            <div class="empty" v-if="DrugList.length == 0">
              <img
                class="m-b-10"
                src="../../assets/img/cxbc/empty.png"
                alt=""
              />
              暂无可领取的草药
            </div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="DrugListFg = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 合成成功 -->
    <van-overlay :show="synSuccess">
      <div class="wrapper">
        <div class="block1">
          <div class="text-center f-18 m-b-5">合成成功!</div>
          <div class="text-center f-18">获得优先购买签</div>
          <img src="../../assets/img/cxbc/sucss-icon.png" alt="" />
          <div class="sucss_Btn f-20" @click="topage('cxbc')">点击购买</div>
        </div>
      </div>
    </van-overlay>
    <!-- 邀请好友获得药草 -->
    <van-overlay :show="invitation">
      <div class="wrapper">
        <div class="block" style="padding: 20px">
          <div class="invitation">
            <div class="herb">
              <img class="img" :src="herbIamge" alt="" />
            </div>
            <div class="getDrug_brief">
              {{ herbintroduce }}
            </div>
            <div class="accept" @click="topage('cxbcShare')">
              邀请好友获得药草
            </div>
            <div class="f-12 text-center">拥有数:{{ zznum }}</div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="invitation = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 赠送好友-->
    <van-overlay :show="zzgive">
      <div class="wrapper">
        <div class="block" style="padding: 20px">
          <div class="invitation">
            <div class="herb">
              <img class="img" :src="herbIamge" alt="" />
            </div>
            <div class="getDrug_brief">
              {{ herbintroduce }}
            </div>
            <div class="accept" @click="invitationa()">赠送好友</div>
            <div class="f-12 text-center">拥有数:{{ zznum }}</div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="zzgive = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 赠送成功 -->
    <van-overlay :show="success">
      <div class="wrapper">
        <div class="block" style="padding: 20px 0; width: 80%">
          <div class="giftconfirm" v-if="fduserdata != null">
            <div class="giftconfirm_title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="30"
                height="30"
                viewBox="0 0 30 30"
              >
                <image
                  id="chenggong"
                  style="margin-right: 9px"
                  width="30"
                  height="30"
                  xlink:href="data:img/png;base64,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"
                />
              </svg>
              <span style="margin-left: 10px">赠送成功</span>
            </div>
            <div class="giftconfirm_cter">
              <div class="giftconfirm_cterti">
                <div>赠送人:</div>
                <div class="font-width text-right">{{ user.nickname }}</div>
              </div>
              <div class="giftconfirm_cterti">
                <div>被赠送人:</div>
                <div class="font-width text-right">
                  {{ fduserdata.username }}
                </div>
              </div>
              <div class="giftconfirm_cterti">
                <div>被赠送人居民卡号:</div>
                <div>{{ fduserdata.code }}</div>
              </div>
              <div class="giftconfirm_cterti">
                <div>赠送时间:</div>
                <div>{{ giveTime }}</div>
              </div>
              <div class="giftconfirm_cterti">
                <div>赠送物品信息:</div>
                <div>{{ herbname }}</div>
              </div>
            </div>
            <div class="giftconfirm_btn" @click="success = false">确认</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 赠送二次确认 -->
    <van-overlay :show="secondaryFG">
      <div class="wrapper">
        <div class="block" style="padding: 20px 0; width: 80%">
          <div class="giftconfirm">
            <div class="giftconfirm_title">
              <span style="margin-left: 10px">赠送好友</span>
            </div>
            <div class="giftconfirm_cter" v-if="fduserdata != null">
              <div class="giftconfirm_cterti">
                <div>赠送药草:</div>
                <div>{{ herbname }}</div>
              </div>
              <div class="giftconfirm_cterti">
                <div>对方昵称:</div>
                <div class="font-width text-right">
                  {{ fduserdata.username }}
                </div>
              </div>
              <div class="giftconfirm_cterti">
                <div>对方手机号:</div>
                <div>{{ fduserdata.mobile }}</div>
              </div>
              <div class="giftconfirm_cterti">
                <div>对方居民卡:</div>
                <div>{{ fduserdata.code }}</div>
              </div>
            </div>
            <div class="Gift_btn_btn m-b-10">
              <div class="closeBtn" @click="cancelGive()">取消赠送</div>
              <div class="ok" @click="give()">确认转赠</div>
              <!-- <div class="nook">确认转赠</div> -->
            </div>
            <div class="text-center f-10">注:赠送后无法撤销,请谨慎选择</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 选择好友 -->
    <van-overlay :show="choiceFd">
      <div class="wrapper">
        <div class="block" style="padding: 20px; width: 80%">
          <div class="choiceFd">
            <div class="choiceFd_title">获得草药</div>
            <div class="Gift_hed">
              <input
                type="number"
                class="choiceFd_inp"
                v-model="mobile"
                @keyup.enter="zzquery"
                placeholder="请输入对方手机号"
              />
              <van-icon class="ser" @click="zzquery" name="search" />
            </div>
            <div class="query" v-if="user_shw && !loding">
              <!-- 查询到了 -->
              <div class="okQuery" v-if="usershow">
                <img
                  v-if="fduserdata !== null"
                  :src="
                    fduserdata.avator !== '0'
                      ? fduserdata.avator
                      : require('../../assets/img/user.png')
                  "
                  width="100%"
                  height="100%"
                  style="border-radius: 50%"
                />
                <div
                  v-if="fduserdata !== null"
                  class="m-l-5 username"
                  style="color: #6d6d6d"
                >
                  {{ fduserdata.username }}
                </div>
              </div>
              <!-- 没查询到 -->
              <div class="okQuery" v-else>
                <div v-if="phoneErr" style="display: flex; align-items: center">
                  <div class="querynouser"></div>
                  <div class="m-l-5" style="color: #6d6d6d">没有查询到用户</div>
                </div>
                <div class="m-l-5" v-if="!phoneErr" style="color: red">
                  手机号有误
                </div>
              </div>
            </div>
            <van-loading v-if="loding" />
            <div class="received">
              <div class="getDrug_imgbox">
                <img class="img" :src="herbIamge" alt="" />
              </div>
            </div>
            <div class="Gift_btn_btn m-b-20">
              <div class="closeBtn" @click="oncolse()">取消赠送</div>
              <div class="ok" v-if="zznum > 0 && usershow" @click="secondary()">
                确认转赠
              </div>
              <div class="nook" v-else>确认转赠</div>
            </div>
            <div class="text-center f-10 m-b-5">
              注：赠送后无法撤销,请谨慎选择
            </div>
            <div class="text-center f-10">拥有数:{{ zznum }}</div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 收到药草 -->
    <van-overlay :show="receivedYc">
      <div class="wrapper" v-if="zzsName != {}">
        <div class="block" style="padding: 20px">
          <div class="receivedYc">
            <div class="receivedYc_title">恭喜你</div>
            <div class="receivedYc_title">收到一株草药</div>
            <div class="herb">
              <img class="img" :src="getherbList[zzimgNum].image" alt="" />
            </div>
            <div class="receivedpop f-14">
              赠送人:
              <img
                :src="
                  zzsName.avator !== '0'
                    ? zzsName.avator
                    : require('../../assets/img/user.png')
                "
                width="100%"
                height="100%"
                style="border-radius: 50%"
              />
              <span class="font-width">{{ zzsName.username }}</span>
            </div>
            <div class="accept" @click="receivedYc = false">收下药草</div>
            <div class="f-10 text-center">
              参加「重寻百草」集齐五张药草 可获得藏品优先购资格
            </div>
            <van-icon
              name="close"
              class="close"
              size="30"
              @click="receivedYc = false"
            />
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 密码确认 -->
    <van-overlay :show="PassVerifi">
      <div class="wrapper">
        <div class="block" style="padding: 30px 10px">
          <div class="PassVerifi">
            <div class="f-20 bold-500 m-b-10 text-center">请输入安全密码</div>
            <div class="f-12 grey m-b-10 text-center">请输入六位数安全密码</div>
            <!-- 密码输入框 -->
            <van-password-input
              :value="password"
              :gutter="10"
              :length="6"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            />
            <!-- 数字键盘 -->
            <van-number-keyboard
              v-model="password"
              :show="showKeyboard"
              @blur="showKeyboard = false"
            />
            <div class="Gift_btn_btn">
              <div class="closeBtn" @click="Passclose()">取消</div>
              <div class="ok" @click="passOk()">确认</div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <login
      :show="isShowLogin"
      @close="isShowLogin = false"
      @success="hasLogin"
    ></login
    ><she-group-dlg
      :isShow="isShowGroup"
      :qrcode="qrcode"
      @qr="qrcodeFN"
      @close="isShowGroup = false"
    ></she-group-dlg>
    <PasswordCxbc
      :isShow="isShowGroup1"
      @qr="qrcodeFN1"
      @close="isShowGroup1 = false"
    ></PasswordCxbc>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import SheGroupDlg from "../../components/PasswordCxbc.vue";
import PasswordCxbc from "../../components/PasswordCxbc2.vue";
import Login from "../../components/Login.vue";
import { userApi } from "../../api/user";
import { getWxConfig } from "../../../tool";
import md5 from "js-md5";
import axios from "axios";
import {
  lottery,
  giveListapi,
  acceptOneApi,
  acceptAllApi,
  userQuery,
  giveApi,
  synthesis,
  hasCode,
  useSecretCode,
} from "../../api/cxbc";
const baseUrl = require("../../../site");
const moment = require("moment");
export default {
  name: "cxbcSynthesis",
  computed: {
    ...mapState({
      user: (state) => state.user,
      isLogin: (state) => state.token,
    }),
  },
  components: { Login, SheGroupDlg, PasswordCxbc },
  data() {
    return {
      loding: false,
      PassVerifi: false, //密码确认
      showKeyboard: true,
      password: "",
      qunFG: false,
      thePublic: false,
      isShowGroup1: false,
      isShowGroup: false,
      isShowLogin: false,
      getDrug: false, //获得草药flag
      DrugListFg: false, //收到草药列表
      synSuccess: false,
      luckDrawDrug: false, //抽到草药
      realName: false, //未实名
      NoPrize: false, //未抽中
      confirm: false, //确认合成
      NoDrug: false, //增列表
      rule: false, //规则
      success: false, // 赠送成功
      invitation: false, //邀请好友
      zzgive: false, //赠送好友
      secondaryFG: false, //二次确认
      choiceFd: false, //选择好友
      receivedYc: false, //收到草药
      usershow: true, //选择好友选项
      user_shw: false, //选择好友选项
      fduserdata: {}, //用户数据
      phoneErr: false, //选择好友选项
      synthesis: false, //合成了吗
      herbIamge: "", //草药图片
      herbname: "", //草药名字
      herbintroduce: "", //草药简介
      giveTime: "", //转赠时间
      page: 1, //转赠列表页码
      last_page: 0, //总页数
      count: 0, //参与人数
      lotteryNum: 0, //剩余抽奖次数
      time: "", //活动结束倒计时
      zzsName: {}, //收到谁的转赠
      zzimgNum: 0,
      timer2: null,
      mobile: "",
      qrcode: "",
      qrcode2: "",
      grass1: 0,
      grass2: 0,
      grass3: 0,
      grass4: 0,
      grass5: 0,
      zznum: 0, //需要转正的数量
      grass: 0, //转正判断
      ysNum: 11111,
      getherbnum: 0,
      getherbList: [
        {
          image: require("../../assets/img/cxbc/blg.png"),
          text: "板蓝根：味苦，性寒。归心、胃经。入心、胃经，具有清热解毒，凉血，利咽之功效，本品苦寒，脾胃虚寒者慎服。",
        },
        {
          image: require("../../assets/img/cxbc/rs.png"),
          text: "人参：味甘，性微寒，归脾、肺经，具有大补元气、补脾益肺、生津止渴、安神益智之功效。",
        },
        {
          image: require("../../assets/img/cxbc/hl.png"),
          text: "黄连：味苦，性寒。归心、肝、胃、大肠经，具有清热燥湿，泻火解毒之功效。",
        },
        {
          image: require("../../assets/img/cxbc/lz.png"),
          text: "灵芝：味苦，性平。归心、肺、肝、肾经，具有健脑、消炎、利尿、益肾之功效。",
        },
        {
          image: require("../../assets/img/cxbc/ac.png"),
          text: "艾草：味苦、辛，性温，纯阳之性，通十二经，具有理血气、逐寒湿、暖子宫、止诸血之功效，灸之能透诸经而除百病。",
        },
      ],
      giveimgList: [
        { img: require("../../assets/img/cxbc/0001.png") },
        { img: require("../../assets/img/cxbc/0001.png") },
        { img: require("../../assets/img/cxbc/0002.png") },
        { img: require("../../assets/img/cxbc/0003.png") },
        { img: require("../../assets/img/cxbc/0004.png") },
        { img: require("../../assets/img/cxbc/0005.png") },
      ],
      DrugList: [],
    };
  },
  created() {
    this.getHerbIndex();
    this.getUser();
    // console.log(this.user);
    getWxConfig(
      "李时珍头像数字藏品火爆预约中",
      "李时珍数字艺术俱乐部，中国中医科学院中医药信息研究所监制，中医数字创新实验室出品。"
    );
  },
  watch: {
    mobile() {
      if (this.mobile.length >= 11) {
        this.zzquery();
      }
      if (8 < this.mobile.length < 11) {
        // this.zzquery();
        this.usershow = false;
      }
      if (this.mobile.length == 0) {
        this.user_shw = false;
      }
    },
  },
  methods: {
    ...mapMutations({
      vxSetUser: "setUser",
    }),
    towc2() {
      this.isShowGroup1 = true;
    },
    closeNoPrize() {
      this.NoPrize = false;
      if (this.lotteryNum <= 1) {
        this.$toast("抽签次数已用尽, 快去邀请吧~");
      }
    },
    hasLogin() {
      this.isShowLogin = false;
      this.getHerbIndex();
    },
    goPassword() {},
    qrcodeFN(v) {
      this.qrcode = v;
    },
    qrcodeFN1(v) {
      this.qrcode2 = v;
    },
    yxgzg() {
      this.$toast("您已获得优先抢购资格");
    },
    confir() {
      this.$toast("您还没凑齐药草 继续努力哦~");
    },
    Passclose() {
      this.password = "";
      this.PassVerifi = false;
      this.usershow = false;
      this.mobile = "";
      this.user_shw = false;
    },
    async passOk() {
      let code = md5("qsxz_" + this.password);
      try {
        const res = await giveApi({
          code: code,
          grass: this.grass,
          mobile: this.mobile,
        });
        if (res.code == 200) {
          this.password = "";
          this.PassVerifi = false;
          this.success = true;
          this.getHerbIndex();
          this.mobile = "";
          this.user_shw = false;
        }
        //密码验证通过后弹出弹窗
      } catch (e) {
        this.password = "";
        this.mobile = "";
        this.user_shw = false;
        this.PassVerifi = false;
        this.$toast(e.data);
      }
    },
    async getUser() {
      try {
        const res = await userApi({});
        this.vxSetUser({
          day: res.data.day,
          join_reserve: res.data.join_reserve,
          isSign: res.data.signs,
          ...res.data.user,
        });
      } catch (e) {
        console.log(e);
        if (e.code === 201) {
          this.isShowLogin = true;
        }
      }
    },
    // 打开赠送好友弹窗
    invitationa() {
      this.zzgive = false;
      this.choiceFd = true;
    },
    // 转正二次确认
    async secondary() {
      try {
        const res = await hasCode({});
        if (!res.data.isHasPhoto) {
          this.$toast("您还未设置安全密码,请前往轻松小镇App设置");
        } else {
          this.choiceFd = false;
          this.secondaryFG = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    //取消转正
    oncolse() {
      this.choiceFd = false;
      this.mobile = "";
      this.usershow = false;
      this.user_shw = false;
    },
    cancelGive() {
      this.secondaryFG = false;
      this.choiceFd = true;
      this.usershow = false;
      this.mobile = "";
      this.user_shw = false;
    },
    // 转赠
    give() {
      console.log("1111");
      this.secondaryFG = false;
      this.PassVerifi = true;
      this.giveTime = moment(new Date()).format("YYYY-MM-DD HH:mm");
      // try {
      //   const res = await giveApi({
      //     grass: this.grass,
      //     mobile: this.mobile,
      //   });
      //   console.log(res);
      //   this.secondaryFG = false;
      //   this.success = true;
      //   this.getHerbIndex();
      //   this.mobile = "";
      //   this.user_shw = false;
      // } catch (e) {
      //   console.log(e);
      //   this.$toast(e.data);
      // }
    },
    // 弹窗收下草药
    accept() {
      console.log("1111");
      if (this.lotteryNum <= 1) {
        this.$toast("抽签次数已用尽, 快去邀请吧~");
      }
      this.getHerbIndex();
      this.getDrug = false;
      this.luckDrawDrug = false;
    },
    // 单个领取
    async indiveReceive(id, i) {
      try {
        const res = await acceptOneApi({
          give_id: id,
        });
        this.zzsName = res.data.give_info;
        this.zzimgNum = this.zzsName.grass - 1;
        this.getherbnum = i - 1;
        this.openList();
        this.receivedYc = true;
        this.getHerbIndex();
      } catch (e) {
        console.log(e);
      }
    },
    // 全部领取
    async allReceive() {
      try {
        const res = await acceptAllApi({});
        this.openList();
        this.getHerbIndex();
        this.$toast("领取成功");
      } catch (e) {
        this.$toast(e.data);
        console.log(e);
      }
    },
    //后一页
    add() {
      if (this.page < this.last_page) {
        this.page++;
        this.openList();
      } else {
        this.$toast("已经是最后一页了");
      }
    },
    // 前一页
    down() {
      if (this.page > 1) {
        this.page--;
        this.openList();
      } else {
        this.$toast("已经是第一页了");
      }
    },
    // 打开收到转正列表
    async openList() {
      try {
        const res = await giveListapi({
          page: this.page,
        });
        this.DrugList = res.data.data.data;
        this.last_page = res.data.data.last_page;
        this.DrugListFg = true;
      } catch (e) {
        console.log(e);
        this.$toast(e.data);
      }
    },
    // 查看药草详情
    cliDetile(v) {
      if (v == "rs") {
        this.zznum = this.grass2;
        this.grass = 2;
        this.herbname = "人参";
        this.herbIamge = require("../../assets/img/cxbc/rs.png");
        this.herbintroduce =
          "人参：味甘，性微寒，归脾、肺经，具有大补元气、补脾益肺、生津止渴、安神益智之功效。";
        if (this.grass2 == 0) {
          this.invitation = true;
        } else {
          this.zzgive = true;
          // this.zznum = this.grass2;
          // this.grass = 2;
          // this.herbname = "人参";
        }
      } else if (v == "blg") {
        this.zznum = this.grass1;
        this.grass = 1;
        this.herbname = "板蓝根";
        this.herbIamge = require("../../assets/img/cxbc/blg.png");
        this.herbintroduce =
          "板蓝根：味苦，性寒。归心、胃经。入心、胃经，具有清热解毒，凉血，利咽之功效，本品苦寒，脾胃虚寒者慎服。";

        if (this.grass1 == 0) {
          this.invitation = true;
        } else {
          this.zzgive = true;
          // this.zznum = this.grass1;
          // this.grass = 1;
          // this.herbname = "板蓝根";
        }
      } else if (v == "hl") {
        this.zznum = this.grass3;
        this.grass = 3;
        this.herbname = "黄连";
        this.herbIamge = require("../../assets/img/cxbc/hl.png");
        this.herbintroduce =
          "黄连：味苦，性寒。归心、肝、胃、大肠经，具有清热燥湿，泻火解毒之功效。";
        if (this.grass3 == 0) {
          this.invitation = true;
        } else {
          this.zzgive = true;
          // this.zznum = this.grass3;
          // this.grass = 3;
          // this.herbname = "黄连";
        }
      } else if (v == "ac") {
        this.zznum = this.grass5;
        this.grass = 5;
        this.herbname = "艾草";
        this.herbIamge = require("../../assets/img/cxbc/ac.png");
        this.herbintroduce =
          "艾草：味苦、辛，性温，纯阳之性，通十二经，具有理血气、逐寒湿、暖子宫、止诸血之功效，灸之能透诸经而除百病";
        if (this.grass5 == 0) {
          this.invitation = true;
        } else {
          this.zzgive = true;
          // this.zznum = this.grass5;
          // this.grass = 5;
          // this.herbname = "艾草";
        }
      } else if (v == "lz") {
        this.zznum = this.grass4;
        this.grass = 4;
        this.herbname = "灵芝";
        this.herbIamge = require("../../assets/img/cxbc/lz.png");
        this.herbintroduce =
          "灵芝：味苦，性平。归心、肺、肝、肾经，具有健脑、消炎、利尿、益肾之功效。";
        if (this.grass4 == 0) {
          this.invitation = true;
        } else {
          this.zzgive = true;
          // this.zznum = this.grass4;
          // this.grass = 4;
          // this.herbname = "灵芝";
        }
      }
    },
    async zzquery() {
      this.loding = true;
      // console.log(this.mobile);
      var TEL_REGEXP =
        /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      this.user_shw = true;
      if (TEL_REGEXP.test(this.mobile)) {
        this.phoneErr = false;
        try {
          const res = await userQuery({
            mobile: this.mobile,
          });
          this.loding = false;

          this.fduserdata = res.data.user;
          if (this.fduserdata != null) {
            this.usershow = true;
            this.phoneErr = false;
          } else {
            this.usershow = false;
            this.phoneErr = true;
          }
          console.log(this.fduserdata);
        } catch (e) {
          console.log(e);
          this.usershow = false;
        }
      } else {
        this.phoneErr = false;
        this.usershow = false;
      }
    },
    // 抽取药草
    async lottery() {
      try {
        const res = await lottery({});
        this.getHerbIndex();
        if (res.data.data == 0) {
          this.NoPrize = true;
        } else {
          this.luckDrawDrug = true;
          this.getherbnum = res.data.data - 1;
        }
      } catch (e) {
        this.$toast(e.data);
      }
    },
    // 合成
    async synthesiss() {
      try {
        const res = await synthesis({});
        if (res.code == 200) {
          this.synSuccess = true;
          this.getUser();
        }
      } catch (e) {
        console.log(e);
        if (e.code == -99) {
          this.realName = true;
        } else {
          this.$toast(e.data);
        }
      }
    },
    // 获取页面数据
    async getHerbIndex() {
      axios
        .post(baseUrl.domain2 + "index/shizhen/grass/", {
          acctoken: localStorage.getItem("token"),
        })
        .then((success) => {
          console.log(success.data);
          this.grass1 = success.data.data.grass1;
          this.grass2 = success.data.data.grass2;
          this.grass3 = success.data.data.grass3;
          this.grass4 = success.data.data.grass4;
          this.grass5 = success.data.data.grass5;
          this.count = success.data.data.count;
          this.lotteryNum = success.data.data.lottery;
          this.synthesis = success.data.data.synthesis;
          this.qrcode = success.data.data.wx_qun;
          this.qunFG = success.data.data.wx_join;
          this.thePublic = success.data.data.thePublic;
          console.log("aaalxlxlxl", this.thePublic);
          this.timer2 = setInterval(() => {
            const time = this.countTime(success.data.data.info.time8 * 1000);
            // console.log(time);
            if (time) {
              this.time = time;
            } else {
              this.time = "00:00:00";
            }
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    countTime(endTime) {
      const now = new Date().getTime();
      const duration = endTime - now;
      if (duration <= 0) {
        return false;
      }
      const day = Math.floor(duration / (1000 * 60 * 60 * 24));
      const hour = Math.floor((duration / (1000 * 60 * 60)) % 24);
      const min = Math.floor((duration / (1000 * 60)) % 60);
      const s = Math.floor((duration / 1000) % 60);
      return `${day ? day + "天" : ""}${hour < 10 ? "0" + hour : hour}:${
        min < 10 ? "0" + min : min
      }:${s < 10 ? "0" + s : s}`;
    },
    topage(name) {
      this.$router.push({
        name,
      });
    },
  },
};
</script>
<style lang="scss">
.cxbcSynthesis {
  // background: url("../../assets/img/cxbc/bg-hecheng.jpg") no-repeat;
  // background-size: 100% 100%;
  background: #0f0d13;
  width: 100%;
  min-height: 100vh;
  .cxbcSynthesis_hed {
    height: 130px;
    width: 100%;
    background: url("../../assets/img/cxbc/cxbcsy-hd.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 30px;
    // position: absolute;
    // z-index: 2;
    .cxbcSynthesis_cet_hed_title {
      color: #fff;
      text-align: center;
      font-size: 16px;
      line-height: 2em;
    }
    .cxbcSynthesis_cet_hed_title2 {
      color: #fff;
      text-align: center;
      font-size: 14px;
      line-height: 2em;
    }
  }
  .cxbcSynthesis_cet {
    .cxbcSynthesis_cet_hed {
      height: 400px;
      background: url("../../assets/img/cxbc/hcBG.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 10px;
      position: relative;
      .rule {
        height: 66px;
        width: 20px;
        position: absolute;
        top: 00px;
        right: 0;
        background: url("../../assets/img/cxbc/rule.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        // border-radius: 5px 0 0 5px;
        // word-wrap: break-word;
        // background: red;
      }
      .min_btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100px;
        color: #000;
        position: absolute;
        top: 53%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .top {
        background-repeat: no-repeat;
        left: 50%;
        top: 80px;
      }
      .mid_one {
        background-repeat: no-repeat;
        left: 17%;
        top: 170px;
      }
      .mid_two {
        background-repeat: no-repeat;
        right: 0%;
        top: 170px;
      }
      .lower_one {
        background-repeat: no-repeat;
        left: 30%;
        top: 320px;
      }
      .lower_two {
        background-repeat: no-repeat;
        left: 70%;
        top: 320px;
      }
      .circle_style {
        background-size: 100% 100%;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
        .num {
          position: absolute;
          width: 20px;
          height: 20px;
          background: #b95399;
          color: #fff;
          font-size: 12px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
          right: 0;
        }
      }
    }
    .cxbcSynthesis_cet_btm {
      // min-height: 300px;
      // background: #1e1b24;
    }
  }
  .cxbcSynthesis_btm {
    // min-height: 110px;
    width: 100%;
    // background: url("../../assets/img/cxbc/cxbcsy-btm.png") no-repeat;
    // background-size: 100% 100%;
    padding: 0 20px 30px;
    .operation_box {
      width: 100%;
      min-height: 200px;
      background: #2e2c38;
      border-radius: 9px;
      padding: 20px 10px 30px;
      color: #fff;
      .operation_box_title {
        color: #fff;
        font-size: 14px;
        text-align: center;
      }
      .operation_box_jt {
        text-align: center;
      }
      .operation_box_popnum {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 5px;
          width: 65px;
        }
        .operation_box_popnums {
          font-size: 12px;
          margin: 0 5px;
        }
      }
      .activity {
        .activity_one {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left {
            display: flex;
            align-items: center;
            img {
              height: 43px;
              width: 43px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .right {
            .btn {
              width: 80px;
              height: 30px;
              background: linear-gradient(81deg, #e8c99a 0%, #f6e0be 97%);
              border-radius: 20px;
              color: #000;
              display: flex;
              align-items: center;
              justify-content: center;
              letter-spacing: 1px;
            }
          }
        }
      }
      .btn_box {
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .received {
          height: 40px;
          width: 120px;
          background: #fffcdb;
          border-radius: 20px;
          color: #000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .extract {
          height: 40px;
          width: 120px;
          background: linear-gradient(160deg, #a5d7f0 0%, #209ddc 97%);
          border-radius: 20px;
          color: #000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .van-overlay {
    background-color: rgba(0, 0, 0, 0.8);
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .block {
        width: 90%;
        background-color: #e6f3f6;
        border-radius: 10px;
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 35px 30px 30px;
        .getDrug {
          .getDrug_title {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
          }
          .getDrug_imgbox {
            position: relative;
            margin: 25px 0 30px;
            img {
              width: 100%;
              border: 10px;
            }
            .name {
              position: absolute;
              bottom: 10px;
              left: 10px;
            }
          }
          .getDrug_brief {
          }
          .accept {
            height: 33px;
            width: 165px;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #000;
            border-radius: 20px;
            margin: 20px auto 0;
          }
        }
        .realName {
          .realName_title {
            line-height: 1.5em;
            text-align: center;
            font-size: 15px;
            font-weight: 400;
          }
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
          .realName_tips {
            text-align: center;
            font-size: 10px;
            margin-top: 20px;
            line-height: 1.5em;
          }
          .to_realName {
            height: 33px;
            width: 165px;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #000;
            border-radius: 20px;
            margin: 20px auto 0;
          }
        }
        .confirm {
          width: 100%;
          .confirm_title {
            text-align: center;
            font-size: 15px;
            margin-bottom: 10px;
          }
          .btn_bx {
            width: 100%;
            margin-top: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .cancel {
              height: 33px;
              width: 100px;
              background: #a1a1a1;
              color: #fff;
              border-radius: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .confirm {
              height: 33px;
              width: 100px;
              background: #000;
              color: #fff;
              border-radius: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        .NoPrize {
          .NoPrize_title {
            font-size: 25px;
            text-align: center;
          }
          .NoPrize_wd {
            text-align: center;
            margin-top: 30px;
          }
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
        }
        .NoDrug {
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
        }
        .rule {
          .rule_title {
            font-size: 16px;
          }
          .rule_wd {
            font-size: 12px;
            margin-top: 5px;
          }
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
        }
        .DrugList {
          width: 100%;
          .DrugList_title {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            position: relative;
            top: -15px;
          }
          .user_list {
            width: 100%;
            padding: 15px;
            background: #fff;
            .user_list_title {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .user_list_title_btn {
                height: 30px;
                width: 90px;
                border-radius: 20px;
                background: #a6d4ae;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .user_list_title_btn1 {
                height: 30px;
                width: 90px;
                border-radius: 20px;
                background: #dddddd;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
            .user_list_list {
              padding: 0 6px;
              .list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 15px;
                .cy {
                  height: 30px;
                  width: 40px;
                }
                .user {
                  display: flex;
                  align-items: center;
                  img {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    margin-right: 5px;
                  }
                  span {
                    width: 6rem;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    overflow: hidden;
                  }
                }
                .listBtn {
                  height: 30px;
                  width: 80px;
                  border-radius: 20px;
                  background: #a6d4ae;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .RevdBtn {
                  height: 30px;
                  width: 80px;
                  border-radius: 20px;
                  background: #dddddd;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
          }
          .paging {
            text-align: center;
            position: relative;
            top: 15px;
          }
          .empty {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
              height: 150px;
              width: 150px;
            }
          }
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
        }
        .invitation {
          width: 100%;
          .invitation_title {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
          }
          .herb {
            position: relative;
            margin: 25px 0 30px;
            img {
              width: 100%;
              border: 10px;
            }
            .name {
              position: absolute;
              bottom: 10px;
              left: 10px;
            }
          }
          .getDrug_brief {
          }
          .accept {
            height: 33px;
            width: 165px;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #000;
            border-radius: 20px;
            margin: 20px auto 10px;
          }
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
        }
        .giftconfirm {
          width: 100%;
          box-shadow: 0px 0px 31px 1px rgba(218, 230, 250, 0.29);
          border-radius: 10px;
          // padding: 20px 0;
          position: relative;
          .close {
            position: absolute;
            top: 420px;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .close1 {
            position: absolute;
            top: 500px;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .giftconfirm_title {
            font-size: 18px;
            font-weight: 800;
            color: #000000;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .giftconfirm_cter {
            width: 100%;
            background: #f3f3f3;
            border-radius: 3px;
            margin-top: 18px;
            color: #000000;
            padding: 25px 25px 10px 25px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .giftconfirm_cterti {
              display: flex;
              margin-bottom: 18px;
              justify-content: space-between;
              font-size: 13px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #000000;
            }
          }
          .giftconfirm_btn {
            width: 120px;
            height: 37px;
            color: #fff;
            border: 1px solid #000000;
            background: #000;
            border-radius: 19px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 20px auto 0;
            letter-spacing: 5px;
          }
          .notes {
            color: #000000;
            font-weight: bold;
            margin-top: 20px;
          }
          .giftconfirm_btn2 {
            width: 120px;
            height: 37px;
            color: #000000;
            border: 1px solid #000000;
            border-radius: 19px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 20px auto 0;
          }
          .Gift_btn_btn {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            padding: 0 30px;
            .closeBtn {
              width: 110px;
              height: 36px;
              background: #a1a1a1;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              line-height: 36px;
            }
            .ok {
              width: 110px;
              height: 36px;
              background: #000;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              text-align: center;
              line-height: 36px;
            }
            .nook {
              width: 110px;
              height: 36px;
              background: #7c7c7c;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              text-align: center;
              line-height: 36px;
            }
          }
        }
        .choiceFd {
          width: 100%;
          .choiceFd_title {
            font-size: 16px;
            font-weight: bold;
            text-align: center;
          }
          .van-loading {
            margin-top: 10px;
          }
          .Gift_hed {
            width: 100%;
            position: relative;
            .choiceFd_inp {
              width: 100%;
              height: 37px;
              border: 1px solid #6d6d6d;
              background: #e6f3f6;
              color: #6d6d6d;
              border-radius: 3px;
              padding-left: 10px;
              padding-right: 30px;
              box-sizing: border-box;
              margin-top: 18px;
            }

            .ser {
              position: absolute;
              color: #000000;
              font-size: 25px;
              top: 25px;
              right: 5px;
            }
          }
          .query {
            padding: 0 20px;
            margin-top: 15px;
            .okQuery {
              display: flex;
              align-items: center;
              .querynouser {
                width: 27px;
                height: 27px;
                background: #606060;
                border-radius: 50%;
              }
              img {
                width: 27px;
                height: 27px;
                border-radius: 50%;
              }
              .username {
                width: 9rem;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
          .received {
            .getDrug_imgbox {
              position: relative;
              margin: 25px 0 30px;
              img {
                width: 70%;
                border: 10px;
              }
              .name {
                position: absolute;
                bottom: 10px;
                left: 10px;
              }
            }
          }
          .Gift_btn_btn {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            .closeBtn {
              width: 110px;
              height: 36px;
              background: #a1a1a1;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              line-height: 36px;
            }
            .ok {
              width: 110px;
              height: 36px;
              background: #000;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              text-align: center;
              line-height: 36px;
            }
            .nook {
              width: 110px;
              height: 36px;
              background: #7c7c7c;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              text-align: center;
              line-height: 36px;
            }
          }
        }
        .receivedYc {
          width: 100%;
          .receivedYc_title {
            font-size: 20px;
            font-weight: bold;
            text-align: center;
          }
          .herb {
            position: relative;
            margin: 25px 0 30px;
            img {
              width: 100%;
              border: 10px;
            }
            .name {
              position: absolute;
              bottom: 10px;
              left: 10px;
            }
          }
          .receivedpop {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              height: 30px;
              width: 30px;
              border-radius: 50%;
              margin: 0 5px 0 15px;
            }
          }
          .accept {
            height: 33px;
            width: 165px;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #000;
            border-radius: 20px;
            margin: 20px auto 10px;
          }
          .close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
          }
        }
        .PassVerifi {
          .van-password-input {
            width: 95%;
            margin: 0 auto;
            .van-password-input__item {
              width: 40px;
              height: 40px;
              border-radius: 5px;
            }
          }
          .Gift_btn_btn {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            padding: 0 25px;
            .closeBtn {
              width: 110px;
              height: 36px;
              background: #a1a1a1;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              line-height: 36px;
            }
            .ok {
              width: 110px;
              height: 36px;
              background: #000;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              text-align: center;
              line-height: 36px;
            }
            .nook {
              width: 110px;
              height: 36px;
              background: #7c7c7c;
              border-radius: 18px;
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              text-align: center;
              line-height: 36px;
            }
          }
        }
      }
      .block1 {
        width: 304px;
        height: 375px;
        background: url("../../assets/img/cxbc/sucss.png") no-repeat;
        background-size: 100% 100%;
        padding-top: 30px;
        text-align: center;
        img {
          width: 160px;
          height: 160px;
          margin: 20px 0 0 35px;
        }
        .sucss_Btn {
          height: 40px;
          width: 160px;
          background: #000;
          margin: 20px auto;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>
